class MainProductSelector extends ProductSelector {
  constructor() {
    super();
  }

  /**
   * On variant change.
   *
   * @param {Object} event
   * @returns {Void}
   */
  onVariantChange(event) {
    super.onVariantChange(event);

    this.updateSelectedLabels();

    if (event.target.type === 'number' || !this.currentVariant) {
      return;
    }

    this.updateMedia();
    this.updateURL();
    this.updatePickupAvailability();

    document.dispatchEvent(
      new CustomEvent('sku:update', {
        detail: { sku: this.currentVariant.sku },
      }),
    );
  }

  /**
   * Update the selected value shown in each option label.
   *
   * @returns {Void}
   */
  updateSelectedLabels() {
    this.querySelectorAll('.product-selector__buttons').forEach((fieldset) => {
      const checked = fieldset.querySelector('input[type="radio"]:checked');
      const label = fieldset.querySelector('[js-current-value]');

      if (checked && label) {
        label.textContent = checked.value;
      }
    });
  }

  /**
   * Retarget the pickup-availability element to the current variant.
   *
   * @returns {Void}
   */
  updatePickupAvailability() {
    const pickup = this.querySelector('pickup-availability');
    if (!pickup) return;

    const url = new URL(pickup.dataset.url, window.location.origin);
    url.searchParams.set('variant', this.currentVariant.id);
    pickup.dataset.url = url.pathname + url.search;
    pickup.dataset.modal = `#Product-Pickup-availability-Modal-${this.currentVariant.id}`;

    const container = pickup.closest('.product__pickup');
    if (container) {
      container.classList.toggle('hidden', !this.currentVariant.available);
    }
  }

  /**
   * Update media.
   *
   * @returns {Void}
   */
  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;

    // const productMedia = document.querySelector('product-media');
    // productMedia.setActiveMedia(this.currentVariant.featured_media.id);
  }

  /**
   * Update URL.
   *
   * @returns {Void}
   */
  updateURL() {
    if (!this.currentVariant) return;
    const params = new URLSearchParams(window.location.search);
    params[params.has('variant') ? 'set' : 'append'](
      'variant',
      this.currentVariant.id,
    );
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?${params.toString()}`,
    );
  }
}

customElements.define('main-product-selector', MainProductSelector);
